module.exports = __webpack_public_path__ + "img/icon-settings-lecho.0f2e0eda.svg";